import { Button } from "@mui/material";
import { memo, ReactNode } from "react";
import CustomBoxModal from "../CustomModalBox";

interface Props {
  text: ReactNode;
  onCancel: () => void;
  onNext: () => void;
}
function ConfirmationModal({ text, onCancel, onNext }: Props) {
  return (
    <CustomBoxModal>
      <div className="my-6">
        <div className="w-72 md:w-92.5 text-center my-3 mx-6.25 text-black font-semibold text-base leading-170">
          {text}
        </div>
        <div className="flex space-x-2 justify-center">
          <Button
            variant="outlined"
            onClick={onCancel}
            className="!text-black !uppercase h-10 w-32 !rounded-xl"
          >
            No
          </Button>
          <Button onClick={onNext} variant="contained" className="!uppercase h-10 w-32 !rounded-xl">
            Yes
          </Button>
        </div>
      </div>
    </CustomBoxModal>
  );
}

export default memo(ConfirmationModal);
